<template>

	<v-content>
		<v-container fluid fill-height>
			<v-layout row>


				<v-flex>
					<v-card>
						<v-toolbar color="#1d202c" dark>
							<v-toolbar-title>Crons</v-toolbar-title>
							<v-spacer></v-spacer>
							<v-btn icon @click="doGetCrons()" :loading="isLoading">
								<v-icon>refresh</v-icon>
							</v-btn>
							<v-btn icon v-if="datachanged" @click="doSaveCrons()" >
								<v-icon color="#00ff00">save</v-icon>
							</v-btn>
							<v-btn icon @click="doAddnewCron()">
								<v-icon>add_circle</v-icon>
							</v-btn>
						</v-toolbar>

						<div class="cronList">

							<template v-if="!isLoaded">
								<div class="text-xs-center pa-5">
									<v-progress-circular :size="50" color="#fff" indeterminate></v-progress-circular>
									<div class="caption mt-4 white--text" >Cron listesi yükleniyor</div>
								</div>
							</template>

							<div class="cronGroup" v-for="(group, groupIndex) in crongroups" :key="'cronGroup'+groupIndex">
								<div class="groupTitle">{{group.title}}</div>
								<div class="groupItem" v-for="(item,itemIndex) in group.items" :key="'cronGroup'+groupIndex+'item'+itemIndex">
									<div class="itemCommand">
										<input type="text" v-model="item.command" @keyup="datachanged=true" @change="datachanged=true">
									</div>
									<div class="itemOptions">
										<input type="text" v-model="item.crontime" @keyup="datachanged=true" @change="datachanged=true">
									</div>
									<div class="itemStatus run-success" :class="{'run-success' : item.success,'run-failed' : !item.success}" >
										<span class="timediff">{{ item.lastrun | moment("from") }}</span>
										<!-- <span class="datestring" update="1">01.04.2019 12:00</span> -->
										<span class="datestring" update="1">{{ item.lastrun | moment("MM.DD.YYYY HH:mm") }}</span>
									</div>
									<div class="itemRemove">
										<span class="removeBtn" @click="doRemoveCron(groupIndex,itemIndex)"><v-icon>cancel</v-icon></span> 
									</div>
								</div>
							</div>

						</div>

					</v-card>
				</v-flex>




			</v-layout>
		</v-container>
	</v-content>


</template>


<script>
	export default {
		name: "ServerCron",
		data() {
			return { 
				isLoading  : true, 
				isLoaded : false,
				crongroups : [],
				datachanged : false,
			}
		},
		watch:{ 
		},
		mounted(){
			this.doGetCrons()
		},
		methods:{
			doLoopGetCrons(){
				this.doGetCrons()
				var self = this;
				setTimeout(function(){
					self.doLoopGetCrons()
				},1000)
			},
			doGetCrons(){
				this.isLoading = true;
				this.$http.get( process.env.VUE_APP_API_URL + "/server/crons" ).then(response => { 
					this.crongroups = response.body;
					this.isLoading = false; 
					this.isLoaded = true; 
					this.datachanged = false;  
				}) 
			},
			doAddnewCron(){
				this.isLoading = true; 
				this.$http.get( process.env.VUE_APP_API_URL + "/server/crons/new" ).then(response => {  
					if(this.crongroups[0].title != ""){
						this.crongroups.unshift({
							"title" : "",
							"items" : []
						}) ; 
					}
					this.crongroups[0].items.push(response.body)
					this.isLoading = false; 
				}) 
			},
			doRemoveCron(groupIndex,itemIndex){
				var item = this.crongroups[groupIndex].items[itemIndex]
				this.isLoading = true; 
				this.$http.get( process.env.VUE_APP_API_URL + "/server/crons/remove?cronId="+item.id ).then(response => {  
					this.crongroups[groupIndex].items.splice(itemIndex,1);
					if(this.crongroups[groupIndex].items.length == 0){
						this.crongroups.splice(groupIndex,1)
					}
					this.isLoading = false; 
				}) 
			},
			doSaveCrons(){ 
				this.isLoading = true; 
				this.$http.post( process.env.VUE_APP_API_URL + "/server/crons/save",{
					groups : this.crongroups
				}).then(response => {   
					this.doGetCrons()
				}) 
			}
		}
	}
</script>




<style lang="less" scoped>
	.cronList {
		width: 100%;
		background: #242833;
		min-height: 200px;
		display: block;
		position: relative;
		overflow: auto;
		.cronGroup {
			margin:10px 5px 10px 10px;
			padding:5px 0px 5px 5px;
			background-color: #2e323d;
			.groupTitle {
				// margin: 10px 10px 0 10px;
				color : #fff;
			}

			.groupItem {
				margin: 0 10px 0 20px;
				display: -webkit-box;
				display: -ms-flexbox;
				display: flex;
				padding: 5px 0;

				input[type="text"] {
					border: none;
					display: block;
					width: 100%;
					font-weight: 300;
					color: hsla(0, 0%, 100%, .459);
					padding: 0 10px;
					line-height: 32px;
					outline: none;
					background-color: #1d202c;
				}

				.itemCommand {
					flex: 1;
				}

				.itemOptions {
					margin-left: 10px;

				}

				.itemStatus {
					line-height: 16px;
					text-align: right;
					width: 120px;
					height: 32px;
					&.run-success{
						color: #00ff4c;
					}
					&.run-failed{
						color : #f30
					}
					.timediff {
						display: block;
					}

					.datestring {
						display: block;
						font-size: 10px;
						color: #8b8b8b;
					}
				}
				.itemRemove{ 
					padding-left: 10px;
					.removeBtn{
						margin-top:3px;
						display: block;
						cursor: pointer;
						&:hover{
							i{color : #a10707}
						}
					}
				}
			}
		}
	}
</style>